import React from "react";

interface IProps {
    onClose(): void;
}

export default (props: IProps): JSX.Element => {
    return (
        <div className="modal is-active">
            <div className="modal-background"></div>
            <div className="modal-card">
                <div className="modal-card-head">
                    <div className="modal-card-title">Not Yet Implemented</div>
                </div>
                <div className="modal-card-body">
                    <section className="modal-card-body">
                        <p>This feature is not yet available in this demo.</p>
                    </section>
                </div>
                <div className="modal-card-foot">
                    <button
                        className="styled-button"
                        type="button"
                        onClick={ props.onClose }
                    >Ok</button>
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/NYIModal.tsx